import { BidHistory } from '@common/pages/Dashboard/components/BidHistory';
import CarDetails from '@common/pages/Dashboard/components/CarDetails';
import { parsedVehicle } from '@common/utils/methods/parsedVehicleForCarData';
import { Box, Divider, Grid, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { reducerPaths } from '../../../../app/reducerPaths';
import theme from '../../../../theme';
import { setAlertDialog } from '../../../../toolkit/alertDialog/alertDialogSlice';
import { useLazyGetAgentDetailsQuery } from '../../../../toolkit/carDetails/carDetailsApi';
import {
  useLazyGetAuctionHistorySellerQuery,
  useLazyGetBidHistoryQuery,
} from '../../../../toolkit/liveAuction/liveAuctionApi';
import { useLazyGetVehicleQuery } from '../../../../toolkit/vehicle/vehicleApi';
import { routes } from '../../../../utils/constants/routes';
import { useLiveAuctionSocketEvents } from '../LiveAuction/customHooks/useLiveAuctionSocketEvents';
import SaleInformation from '../SaleInformation';
import { mainContainer } from '../VehicleInfoSidebarSx';
import { sidebarBox, topButtonContainer } from './UpcomingCarsDetailSx';
import CarDetailSkeleton from '@common/pages/Dashboard/components/CarDetailsSkeleton';
import CostBreakdownSeller from "@common/components/custom/CostBreakdownSection/CostBreakdownSeller";

// Main Car Detail Page component
const UpcomingCarsDetail = ({
  setDetailView,
  // selectedCar = {},
  // setSelectedCar
}) => {
  const isMobile = useMediaQuery('(max-width:1300px)');

  // useLocation...
  const location = useLocation();
  // useLocation...

  const Vehicle_Id = location?.pathname?.split?.(`${routes.upcomingCars}/`)?.[1];

  // useDispatch...
  const dispatch = useDispatch();
  // useDispatch...

  const liveAuction = useSelector((store) => store[reducerPaths.liveAuction]);

  // useState variables start...
  const [selectedCar, setSelectedCar] = React.useState(null);
  // useState variables end...

  // const { data: agentDetails, isFetching } = useGetAgentDetailsQuery({
  //   vehicleId: selectedCar?.Vehicle_Id,
  // });

  // Handlers start...
  // const parsedVehicle = (selectedCar) => {
  //   const images = [];
  //   const carImages = getImagesHandler({
  //     data: {
  //       vehicle: selectedCar
  //     }
  //   });

  //   for (let i = 0; i < Object.entries(carImages?.images)?.length; i++) {
  //     for (let j = 0; j < Object.entries(carImages?.images)?.[i]?.[1]?.length; j++) {
  //       if (Object.entries(carImages?.images)?.[i]?.[1]?.[j]) {
  //         images.push(Object.entries(carImages?.images)?.[i]?.[1]?.[j])
  //       }
  //     }
  //   }

  //   return {
  //     ...selectedCar,
  //     images
  //   };
  // }

  const onNewBidHandler = async () => {
    await getBidHistoryApiHandler({
      vehicleId: selectedCar?.Vehicle_Id,
    });
  };
  // Handlers end...

  const [getAgentDetailsApiHandler, getAgentDetailsApiData] = useLazyGetAgentDetailsQuery();
  const [getVehicleApiHandler, getVehicleApiData] = useLazyGetVehicleQuery();
  const [getBidHistoryApiHandler, getBidHistoryApiData] = useLazyGetBidHistoryQuery();
  const [getAuctionHistorySellerApiHandler, getAuctionHistorySellerApiData] = useLazyGetAuctionHistorySellerQuery();

  useLiveAuctionSocketEvents({
    Vehicle_Id: selectedCar?.Vehicle_Id,
    onNewBidHandler,
  });

  // useEffect start...
  React.useEffect(() => {
    if (Vehicle_Id) {
      (async () => {
        const res = await getVehicleApiHandler({
          Vehicle_Id,
        });

        console.log(res, `getVehicleApiHandler`);

        if (res?.error) {
          dispatch(
            setAlertDialog({
              open: true,
              title: `Error`,
              message: res?.error?.data?.error || res?.error?.data?.message || `Some error occured!`,
            })
          );
        } else {
          setSelectedCar(res?.data?.vehicle);
        }
      })();
    }
  }, [Vehicle_Id]);

  React.useEffect(() => {
    if (Vehicle_Id) {
      (async () => {
        const res = await getAgentDetailsApiHandler({
          vehicleId: Vehicle_Id,
        });

        console.log(res, `getAgentDetailsApiHandler`);

        if (res?.error) {
          dispatch(
            setAlertDialog({
              open: true,
              title: `Error`,
              message: res?.error?.data?.error || res?.error?.data?.message || `Some error occured!`,
            })
          );
        }
      })();
    }
  }, [Vehicle_Id]);

  React.useEffect(() => {
    if (!selectedCar?.Vehicle_Id) {
      return;
    }

    (async () => {
      const res = await getBidHistoryApiHandler({
        vehicleId: selectedCar?.Vehicle_Id,
      });

      if (res?.error) {
        dispatch(
          setAlertDialog({
            open: true,
            title: `Error!`,
            message: res?.error?.data?.message || res?.error?.data?.error || `Some error occured!`,
          })
        );
      }

      console.log(res, `getBidHistoryApiHandler`);
    })();
  }, [selectedCar]);

  React.useEffect(() => {
    if (!Vehicle_Id) {
      return;
    }

    (async () => {
      await getAuctionHistorySellerApiHandler({
        Vehicle_Id,
      });
    })();
  }, [Vehicle_Id]);
  // useEffect end...

  return (
    <Grid container spacing={0} sx={mainContainer}>
      {getVehicleApiData?.isFetching || !selectedCar ? (
        <CarDetailSkeleton />
      ) : (
        <>
          {/* Left sidebar with buttons */}
          <Grid size={{ xl: 2.8 - 0.2, lg: 4 - 0.2, md: 12, sm: 12, xs: 12 }}>
            <Box sx={sidebarBox}>
              {/* Relist and Previous Auction 2 Buttons */}
              {/* <Box sx={topButtonContainer}>
                <Button variant="contained" fullWidth startIcon={<img src={auctionLogo} />} sx={sidebarButton}>
                  Previous Auctions
                </Button>
              </Box> */}

              <BidHistory
                selectedCar={selectedCar}
                bids={liveAuction?.bidHistory?.data || []}
                isLoading={getBidHistoryApiData?.isLoading}
              />

              <CostBreakdownSeller 
                car={selectedCar}
              />

              {/* Sale Information */}
              <SaleInformation data={getAgentDetailsApiData?.data?.[0]} car={selectedCar} />
            </Box>
          </Grid>
          <Divider orientation={'vertical'} flexItem />
          {/* Right Section - 70% */}
          <Grid size={{ xl: 9.2 - 0.2, lg: 8 - 0.2, md: 12, sm: 12, xs: 12 }}>
            <CarDetails car={parsedVehicle(selectedCar)} showEdit />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default UpcomingCarsDetail;
